
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WidgetsService } from 'src/app/services/widgets/widgets.service';
import { WidgetsAbstract } from 'src/app/abstract/widgets/widgets.abstract';
import { Logger } from 'src/app/core/logger';
import { WidgetsContainerComponentAbstract } from 'src/app/abstract/widgets/widgets-container-component.abstract';
import { CdkDrag, CdkDragDrop } from '@angular/cdk/drag-drop';
import { WidgetsTypeEnum } from 'src/app/enums/widgets/widgets-type.enum';
import { ValdnWidgetsComparisonModel } from 'src/app/models/widgets-validation/valdn-widgets-comparison.model';
import { ValdnWidgetsDateModel } from 'src/app/models/widgets-validation/valdn-widgets-date.model';
import { ValdnWidgetsIPModel } from 'src/app/models/widgets-validation/valdn-widgets-ip.model';
import { WidgetsCheckboxModel } from 'src/app/models/widgets/widgets-checkbox.model';
import { WidgetsNotifyDeleteService } from 'src/app/services/widgets/widgets-notify-delete.service';
import { WidgetsSelectionService } from 'src/app/services/widgets/widgets-selection.service';

@Component({
  selector: '[appWidgetsCheckbox]',
  templateUrl: './widgets-checkbox.component.html',
  styleUrls: ['./widgets-checkbox.component.scss']
})
export class WidgetsCheckboxComponent extends WidgetsContainerComponentAbstract implements OnInit {

  @Input() data: WidgetsCheckboxModel = new WidgetsCheckboxModel();
  @Input() dropListIds: string[] = [];
  @Output() dropListIdAdded: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private widgetsService: WidgetsService,
    private selectionService: WidgetsSelectionService,
    private notifyDeleteService: WidgetsNotifyDeleteService,
    private logger: Logger) {
      super();
  }

  ngOnInit(): void {
    // this.data.key = this.widgetsService.getNextKey(this.data.type);
  }

  onWidgetDroppedToCanvas(event: CdkDragDrop<WidgetsAbstract[], WidgetsAbstract[], any>): WidgetsAbstract {
    switch (event.item.data.widgetType) {
      case WidgetsTypeEnum.VALDN_COMP:
        // Pending: return model for specific validation
        return new ValdnWidgetsComparisonModel();
      case WidgetsTypeEnum.VALDN_DATE:
          return new ValdnWidgetsDateModel();
      case WidgetsTypeEnum.VALDN_IP:
        return new ValdnWidgetsIPModel();

    }

    return {} as WidgetsAbstract;
  }

  isDroppableWidget(item: CdkDrag<WidgetsAbstract>) {
    switch (item.data.widgetType) {
      case WidgetsTypeEnum.VALDN_COMP:
      case WidgetsTypeEnum.VALDN_DATE:
      case WidgetsTypeEnum.VALDN_IP:
        return true;
    }

    return false;
  }

  onDeleteModal(): void {
    this.notifyDeleteService.notifyDelete(this.data);
  }

  onDebug() {
    // console.log("debug");
  }

  clone(orgWidget: WidgetsCheckboxModel): WidgetsAbstract {
    const newInput = new WidgetsCheckboxModel();
    newInput.type = 'checkbox';
    newInput.key = orgWidget.key;
    newInput.label = orgWidget.label;
    newInput.description = orgWidget.description;
    newInput.required = orgWidget.required;
    newInput.template = orgWidget.template;
    return newInput;
  }

  onWidgetsReordered(culprits: WidgetsAbstract[]) {
    throw new Error('Method not implemented.');
  }

  onSelect() {
    this.selectionService.toggleSelection(this.data);
  }
}
